module.exports = __webpack_public_path__ + "97efdbc7e785a220ca54d82fcaebc340.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/phone.png
// module id = ./assets/images/advisory/phone.png
// module chunks = 0